import { restCmsRepository, CareerType } from "@onair/repositories";
import { unstable_noStore } from "next/cache";

export const getLearningDeverlopmentPage = async () => {
	unstable_noStore();
	const response =
		await restCmsRepository.learningAndDevelopment.getLearningAndDevelopment({
			// populate: "*",
			"populate[0]": "seo.metaThumbnail",
			"populate[1]": "boxesContentOne.items.thumbnail",
			"populate[2]": "carousel.image",
			"populate[3]": "subscription.bgImage",
			"populate[4]": "groupCategories.categories",
			"populate[5]": "document",
			"populate[6]": "courses.bgImage",
			"populate[7]": "stories.items.thumbnail",
			"populate[8]": "blogSection.categories",
		} as Record<string, string>);
	return response.data;
};

export interface LearningAndDevelopmentPostQueryFilter {
	pageSize?: number;
	page?: number;
	categories?: number[];
	onlyLnD?: boolean;
	searchText?: string;
}

export const getLearningAndDevelopmentPosts = async (
	filter?: LearningAndDevelopmentPostQueryFilter,
) => {
	unstable_noStore();
	const {
		pageSize = 10,
		page = 1,
		categories,
		onlyLnD = true,
		searchText,
	} = filter || {};

	let query = {
		"populate[banner][fields][0]": "url",
		"populate[banner][fields][1]": "width",
		"populate[banner][fields][2]": "height",
		"populate[banner][fields][3]": "alternativeText",
		"populate[hashtags][fields][0]": "slug",
		"populate[hashtags][fields][1]": "name",
		"populate[post_categories][fields][0]": "id",
		"populate[post_categories][fields][1]": "slug",
		"populate[post_categories][fields][2]": "title",
		"populate[author][fields][0]": "username",
		"populate[author][populate][avatar][fields][0]": "alternativeText",
		"populate[author][populate][avatar][fields][1]": "url",
		"populate[author][populate][avatar][fields][2]": "width",
		"populate[author][populate][avatar][fields][3]": "height",
		"pagination[page]": page,
		"pagination[pageSize]": pageSize,
		"sort[0]": "createdAt:desc",
	} as Record<string, string | number>;

	if (onlyLnD) {
		query = { ...query, "filters[isLearningAndDevelopment][$eq]": "1" };
	}

	if (searchText) {
		query = { ...query, "filters[title][$containsi]": searchText };
	}

	if (categories?.length) {
		const categoriesToQueryObject = categories.reduce<Record<string, string>>(
			(acc, catId, _index) => ({
				...acc,
				[`filters[post_categories][id][$in][${_index}]`]: catId.toString(),
			}),
			{},
		);
		query = { ...query, ...categoriesToQueryObject };
	}
	const response = await restCmsRepository.posts.getPosts(query);
	return response.data;
};

export const getBlogLandingLnD = async () => {
	unstable_noStore();
	const response =
		await restCmsRepository.blogLearningAndDevelopment.getBlogLearningAndDevelopment(
			{
				"populate[0]": "seo.metaThumbnail",
				"populate[1]": "categories",
				"populate[2]": "headerImage",
			} as Record<string, string | number>,
		);
	return response.data;
};

export const getPostDetailBySlugLnD = async (slug: string) => {
	unstable_noStore();
	const response = await restCmsRepository.posts.getPosts({
		"filters[slug][$eq]": slug,
		"populate[author][populate][avatar][fields][0]": "alternativeText",
		"populate[author][populate][avatar][fields][1]": "url",
		"populate[author][populate][avatar][fields][2]": "width",
		"populate[author][populate][avatar][fields][3]": "height",
		"populate[banner][fields][0]": "*",
		"populate[post_categories][fields][0]": "*",
		"populate[hashtags][fields][0]": "*",
	} as Record<string, string | number>);
	return response.data["data"]?.[0];
};

export const getCategoryDetailBySlugLnD = async (slug: string) => {
	unstable_noStore();
	const response = await restCmsRepository.categories.getCategories({
		"filters[slug][$eq]": slug,
		"populate[thumbnail][populate]": "*",
		"populate[seoMeta][populate]": "*",
		// "populate[banner][fields][0]": "*",
		// "populate[post_categories][fields][0]": "*",
		// "populate[hashtags][fields][0]": "*",
	} as Record<string, string | number>);
	return response.data["data"]?.[0];
};
